module.exports = __webpack_public_path__ + "img/file_view_details.bca45483.png";